// src/hooks/useOverlayScrollLock.js
import { useEffect } from "react";

/**
 * Trava e RESTAURA o scroller real do app enquanto um overlay `position: fixed`
 * (que NÃO passa pelo <SwipeableOffcanvas>) estiver ativo.
 *
 * Reaproveita a mesma ideia do SwipeableOffcanvas / RouteOverflowController:
 * ao ativar, salva o estado do scroller (.containerTabPane) + body; ao
 * desativar/desmontar, RESTAURA overflow e scrollTop ao valor anterior — assim o
 * scroll do pai volta ao normal quando o overlay fecha.
 *
 * Alvos previstos: overlay de nível do PublishButton e a StreakScreen — hoje
 * fora da cobertura do wrapper (Fase 0).
 *
 * A classe do scroller é hasheada (CSS Modules), por isso o seletor por
 * substring [class*="containerTabPane"] em vez de .containerTabPane.
 *
 * @param {boolean} active  overlay visível/montado
 */
export default function useOverlayScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;

    const scroller = document.querySelector('[class*="containerTabPane"]');
    const body = document.body;
    const html = document.documentElement;

    const prev = {
      scrollTop:        scroller ? scroller.scrollTop : 0,
      scrollerOverflow: scroller ? scroller.style.overflow : "",
      bodyOverflow:     body.style.overflow,
      htmlOverflow:     html.style.overflow,
      winY:             window.scrollY || 0,
    };

    if (scroller) scroller.style.overflow = "hidden";
    body.style.overflow = "hidden";

    return () => {
      if (scroller) {
        scroller.style.overflow = prev.scrollerOverflow;
        // restaura a posição de scroll do scroller pai (evita "scroll preso")
        scroller.scrollTop = prev.scrollTop;
      }
      body.style.overflow = prev.bodyOverflow;
      html.style.overflow = prev.htmlOverflow;
      // iOS às vezes desloca o scroll da janela ao fechar overlays fixed
      window.scrollTo(0, prev.winY);
    };
  }, [active]);
}
